<template>
    <main role="main">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="page-bn s6-1bn" :style="{'background-image': 'url(' + data.src + ')' }">
          <div style="height: 500px;overflow: hidden;width: 100%;z-index: -2;">
            <div style="width: 100%;height: 500px;background-size: cover;filter: blur(4px);z-index: -1;" 
            :style="{'background-image': 'url(' + data.src + ')' }" ></div>
          </div>
          
          <div class="bn-title-box">
            <p class="time">{{data.date}}</p>
            <h4>{{data.title}}</h4>
          </div>
        </div>
        <div>
            <div class="detailed-con s6-1" >
            <h5>{{data.desc}}</h5>
            <div class="s6-img-box">
              <div class="tz-gallery">
              <div class="row">
                <div class="col-sm-6 col-md-3" v-for="(item) in images" :key="item.id">
                  <div class="thumbnail">
                      <a class="lightbox" :href="item.src">
                        <div class="lightbox-img" :style="{ 'background-image': 'url('+ item.src+')' }" ></div>
                      </a>
                  </div>
                </div>
              </div>
            </div>
            </div>  
            <a class="back-btn" href="/activity">back</a>
            </div>
        </div>
        <IndexFooter></IndexFooter>
    </main>
    
</template>

<script>
import {fb, db } from '../../firebase'
export default {
  name: 'Activity',
  data () {
    return {
        id:this.$route.params.id,
        data:{
            title:'',
            date:'',
            desc:'',
            src:'',
            height:'',
            width:'',
        },
        images:[],
        isLoading: false
    }
  },
  mounted () {
    this.Get();
  },
  methods: {
    Get(){
      this.isLoading = true;
      db.collection(this.$t('DB.ACTIVITY')).doc(this.id).get().then((doc) => {
          if (doc.exists) {
            this.data = doc.data();
            for ( var i = 0 ; i < this.data.images.length ; i++ ) {
              var tmp = {
                  id:       this.data.images[i].id,
                  caption:  this.data.images[i].name,
                  name:     this.data.images[i].name,
                  src:      this.data.images[i].src,
                  thumbnail:this.data.images[i].thumbnail,
                  order:    this.data.images[i].order
              }
              this.images.push(tmp);
            }
            this.images.sort( (d1, d2) => d1.order - d2.order);
            this.isLoading = false;
            setTimeout(function(){
              baguetteBox.run('.tz-gallery');
            },200)
          } else {
            this.$router.push({name: 'IndexActivity'}); 
          }
      }).catch((error) => {
          console.log("Error getting document:", error);
          this.isLoading = false;
      });
    }
  }
}
</script>
<style src="../../../static/css/baguetteBox.min.css"></style>


// WEBPACK FOOTER //
// src/components/index/ActivityInfo.vue